// pcapi
const devBaseURL = "https://api.gtwealth.ca"; // 正式环境
// const devBaseURL = "http://72.14.183.204:8090"; // 测试环境

export const BASE_URL = process.env.NODE_ENV === 'development' ? devBaseURL : devBaseURL;

export const ImageURL = "https://api.gtwealth.ca/static/"
// export const ImageURL = "http://72.14.183.204:8090/static/"
export const TIMEOUT = 5000;
